// business.actions.ts
import { createAction, props } from '@ngrx/store'
import { Business } from './business.state'

// Action to load businesses
export const loadBusinesses = createAction(
  '[Business] Load Businesses',
  props<{ params?: string | null; page?: number; limit?: number; context?: 'list' | 'modal' }>()
)

// Action for successful business load
export const loadBusinessesSuccess = createAction(
  '[Business] Load Businesses Success',
  props<{
    totalCount: number
    activeCount: number
    inactiveCount: number
    totalOffices: number
    totalDepartments: number
    totalDesignations: number
    businesses: Business[]
    totalRowCount: number
    context?: 'list' | 'modal'
  }>()
)

// Action for business load failure
export const loadBusinessesFailure = createAction(
  '[Business] Load Businesses Failure',
  props<{ error: string }>()
)

export const blockBusiness = createAction(
  '[Business] Block Business',
  props<{ id: string; disabled: boolean }>()
)

export const unblockBusiness = createAction(
  '[Business] Unblock Business',
  props<{ id: string; disabled: boolean }>()
)

export const blockBusinessSuccess = createAction(
  '[Business] Block Business Success',
  props<{ business: Business }>()
)

export const unblockBusinessSuccess = createAction(
  '[Business] Unblock Business Success',
  props<{ id: string }>()
)

export const blockBusinessFailure = createAction(
  '[Business] Block Business Failure',
  props<{ error: string }>()
)

export const unblockBusinessFailure = createAction(
  '[Business] Unblock Business Failure',
  props<{ error: string }>()
)

export const deleteBusiness = createAction('[Business] Delete Business', props<{ id: string }>())

export const deleteBusinessSuccess = createAction(
  '[Business] Delete Business Success',
  props<{ id: string }>()
)

export const deleteBusinessFailure = createAction(
  '[Business] Delete Business Failure',
  props<{ error: any }>()
)

export const loadBusinessCounts = createAction('[Business] Load Counts')
export const setBusinessCounts = createAction(
  '[Business] Set Counts',
  props<{ totalCount: number; activeCount: number; inactiveCount: number; totalRowCount: number }>()
)

export const createBusiness = createAction(
  '[Business] Create Business',
  props<{
    businessName: string
    picture: string | null
    website: string
    userId: string
    parentBusinessId: string | null
  }>()
)

export const createBusinessSuccess = createAction(
  '[Business] Create Business Success',
  props<{ business: Business }>()
)

export const createBusinessFailure = createAction(
  '[Business] Create Business Failure',
  props<{ error: any }>()
)

// Action to initiate loading of business by ID
export const loadBusinessById = createAction(
  '[Business] Load Business By ID',
  props<{ id: string }>()
)

// Action when business data is loaded successfully
export const loadBusinessByIdSuccess = createAction(
  '[Business] Load Business By ID Success',
  props<{ business: Business }>()
)

// Action when there is an error loading the business data
export const loadBusinessByIdFailure = createAction(
  '[Business] Load Business By ID Failure',
  props<{ error: string }>()
)

export const updateBusiness = createAction(
  '[Business] Update Business',
  props<{
    id: string
    businessName: string
    picture: string | null
    website: string
    address: string
    cityId: number
    zipCode: string
    referenceIdFacebook: string
    referenceIdInstagram: string
    referenceIdLinkedIn: string
    referenceIdTwitter: string
    referenceIdWhatsapp: string
    empidprefix?: string | null
    empidprefixStart?: string | null
    contractoridprefix?: string | null
    contractoridprefixStart?: string | null
    traineeidprefix?: string | null
    traineeidprefixStart?: string | null
    currencyId?: number | null
    incorporationNo?: string | null
    incorporationDate?: Date | null
    PAN?: string | null
    GST?: string | null
    userId?: string | null
    latitude?: number | null | undefined
    longitude?: number | null | undefined
    isAutoClockInOut?: boolean
    isMobileApp?: boolean
  }>()
)

export const updateBusinessSuccess = createAction(
  '[Business] Update Business Success',
  props<{ business: Business }>()
)

export const updateBusinessFailure = createAction(
  '[Business] Update Business Failure',
  props<{ error: any }>()
)

export const assignOwner = createAction(
  '[Business] Assign Business Owner',
  props<{
    id: string
    userId: string
  }>()
)

export const assignOwnerSuccess = createAction(
  '[Business] Assign Business Owner Success',
  props<{ business: Business }>()
)

export const assignOwnerFailure = createAction(
  '[Business] Assign Business Owner Failure',
  props<{ error: any }>()
)

export const resetBusinessState = createAction('[Business] Reset State')
